import createReducer from '../createReducer';
import {TTimetable} from './timetable.type';

const initialState: TTimetable = {
    lectures: {},
    getLecturesXHR: {},
    moveLectureXHR: null,
    deleteLectureXHR: null,
    duplicateLectureXHR: null,
    currentDayIndex: 0,
    lecturers: [],
    halls: [],
    slots: [],
};

const reducer = createReducer('timetable', initialState);

export default reducer;
